import React, { useContext, useState, useEffect } from "react";

import {
  IonCard,
  IonCardContent,
  IonItem,
  IonIcon,
  IonLabel,
  IonInput,
  IonButton,
  IonSpinner,
  IonText,
} from "@ionic/react";

import {
  callOutline,
  personCircleOutline,
  mailOutline,
  fingerPrintOutline,
} from "ionicons/icons";

import { useHistory } from "react-router-dom";

import Page from "../../components/Page/Page";

import { AppContext, AppContextDefaultValue } from "../../base/AppContext";

import { useChange } from "../../hooks/useChange";
import { useUpdate } from "../../hooks/useAccountUpdate";
import { useValidation, options } from "../../hooks/useValidation";

import { AlertInfoUpdateFail } from "../../components/Alert";

import "./style.css";

const Account: React.FC = () => {
  const [state, setState] = useState({ ...AppContextDefaultValue.user });
  const { user, refreshUser } = useContext(AppContext);
  const { goBack } = useHistory();

  useEffect(() => {
    setState((prevState) => ({
      ...prevState,
      ...user,
    }));
  }, [user]);

  const { errors, setError, isValid } = useValidation(state as options);

  const { onIonChange } = useChange({ setState, setFormError: setError });

  const [updateAccount, { loading, error }] = useUpdate();

  const getValid = (name = "name") => {
    return errors[name] ? "danger" : "";
  };

  const onSubmit = (event: any) => {
    event.preventDefault();
    updateAccount({ variables: state })
      .then((res) => {
        refreshUser();
        goBack();
      })
      .catch((err) => {
        console.log(err, "error");
      });
  };

  return (
    <Page name="Editar dados" back="/page/my-account">
      <IonCard>
        <IonCardContent className="no-padding">
          <AlertInfoUpdateFail
            onWillDimiss={() => {}}
            time={0}
            show={!loading && Boolean(error)}
          />
          <form onSubmit={onSubmit}>
            <IonItem lines="full">
              <IonIcon slot="start" icon={personCircleOutline} />
              <IonLabel color={getValid(state.name)} position="floating">
                Nome
              </IonLabel>
              <IonInput
                name="name"
                color={getValid()}
                value={state.name}
                placeholder="Ex: William Vilas Boas"
                onIonChange={onIonChange}
              />
            </IonItem>
            <IonItem lines="full">
              <IonIcon slot="start" icon={mailOutline} />
              <IonLabel color={getValid(state.email)} position="floating">
                E-mail
              </IonLabel>
              <IonInput
                name="email"
                color={getValid("email")}
                value={state.email}
                placeholder="Ex: william.vboas@gmail.com"
                onIonChange={onIonChange}
              />
            </IonItem>
            <IonItem lines="full">
              <IonIcon slot="start" icon={callOutline} />
              <IonLabel color={getValid("phone")} position="floating">
                Telefone
              </IonLabel>
              <IonInput
                name="phone"
                color={getValid("phone")}
                value={state.phone}
                placeholder="Ex: 71991773639"
                onIonChange={onIonChange}
              />
            </IonItem>
            <IonItem lines="full">
              <IonIcon slot="start" icon={fingerPrintOutline} />
              <IonLabel color={getValid("cic")} position="floating">
                CPF
              </IonLabel>
              <IonInput
                name="cic"
                value={state.cic}
                placeholder="Ex: 06621563592"
                onIonChange={onIonChange}
                color={getValid("cic")}
                required
              />
            </IonItem>
            <IonButton
              disabled={isValid() || loading}
              type="submit"
              className="btn-save"
            >
              {loading ? <IonSpinner slot="start" /> : null}
              <IonText>{loading ? "Salvando..." : "Salvar"}</IonText>
            </IonButton>
          </form>
        </IonCardContent>
      </IonCard>
    </Page>
  );
};

export default Account;
